export function getDependentError(errors, index, field) {
  if (!errors) return "";
  return errors["dependents"] ? errors["dependents"][index]?.[field] : "";
}
